import { TASK_AUTOMATION_STATUS } from "@/helpers/constants"
import {formatSysDateTime} from "@/plugins/formatting";

export const getSaveDataRecipientsList = (type, recipients) => {
    let mappedRecipients = []
    for (let recipient of recipients) {
        if (recipient.custom_type) {
            mappedRecipients.push({
                name: recipient.name ? recipient.name : recipient.surname,
                custom_value: recipient.custom_value,
                custom_type: recipient.custom_type,
                related_type: recipient.related_type,
                type: type
            })
        } else {
            mappedRecipients.push({
                name: recipient.name ? recipient.name : recipient.surname,
                email: recipient.email,
                type: type,
                id: recipient.id
            })
        }
    }

    return mappedRecipients
}

export const getSaveDataRecipients = (toRecipients, ccRecipients, bccRecipients) => {
    let recipients = []
    recipients = recipients.concat(getSaveDataRecipientsList('to', toRecipients))
    recipients = recipients.concat(getSaveDataRecipientsList('cc', ccRecipients))
    recipients = recipients.concat(getSaveDataRecipientsList('bcc', bccRecipients))

    return recipients
}

export const getSaveData = (
    isAutomation,
    selectedDays,
    selectedTrigger,
    taskAutomationId,
    templateId,
    subject,
    content,
    files,
    localeCode,
    emailIntegrationId,
    toRecipients,
    ccRecipients,
    bccRecipients
) => {
    const days = isAutomation ? selectedDays : 0
    const trigger = isAutomation ? selectedTrigger : ''
    const date = formatSysDateTime(new Date())

    return {
        id: taskAutomationId,
        content_template_id: templateId === -1 ? null : templateId,
        subject: templateId ? null : subject,
        content: templateId ? null : content,
        created_at: date,
        status: TASK_AUTOMATION_STATUS.NEW,
        attachments: files,
        trigger: trigger,
        days: days,
        locale_code: localeCode,
        email_integration_id: emailIntegrationId === -1 ? null : emailIntegrationId, // In case of client default we set it to null
        is_email_integration_client_default: emailIntegrationId === -1,
        data: {
            recipients: getSaveDataRecipients(
                toRecipients,
                ccRecipients,
                bccRecipients
            )
        }
    }
}

export const addNameToRecipientsWithContact = (recipients, contactTabs) => {
    let newRecipients = []

    for (let recipient of recipients) {
        for (let tab in contactTabs) {
            for (let contact in tab.contacts) {
                if (contact.id === recipient.id) {
                    recipient.name = contact.name
                }
            }
        }

        newRecipients.push(recipient)
    }

    return newRecipients
}

export default {
    getSaveDataRecipientsList,
    getSaveData,
    addNameToRecipientsWithContact
}